import { ClientConfigProductName } from '@frontend/vanilla/core';

export const MainComponentLoader = {
    id: 'ms-main-component',
    loaderFn: () => import(/* webpackChunkName: "ms-main-component" */ './main.component').then(() => []),
    product: ClientConfigProductName.SPORTS,
};
